module.exports = __webpack_public_path__ + "x3.no1.874dfb6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x3.no1.jpg
// module id = GCOx
// module chunks = 0